import { render, staticRenderFns } from "./OrderTabDetails.vue?vue&type=template&id=61cfcf94&scoped=true&"
import script from "./OrderTabDetails.vue?vue&type=script&lang=ts&"
export * from "./OrderTabDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cfcf94",
  null
  
)

export default component.exports